module.exports = __webpack_public_path__ + "img/assistant-4.acb1090b.jpg";